export const localization = {
  en: {
    loadMore: 'Load More'
  },
  es: {
    loadMore: 'Cargar más'
  },
  keyMapping: {
    loadMore: 'UFD_Load_More_Button'
  }
}
